/*
 * @Author: llzq
 * @Date: 2021-10-24 13:32:01
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 14:14:30
 * @Description:  头部注释
 */
import React, { Component } from "react";
import {Select,Spin} from "antd";
import { SelectValue, LabeledValue } from "antd/lib/select";
import Person from "./models/person";
import CommonUser from '../models/commonUser'
import AppService from "../service/app.service";
import "./style.css";
const { Option } = Select;
interface iProps {
  defaultValue?: string[];
  value?: string[];
  allowClear?: boolean;
  placeholder?: string;
  url?: string;
  userType?: string;
  onChange?: (value: string[]) => void;
  params?:any;
  disabledComp?: boolean
}
interface iState {
  options: Person[];
  fetching: boolean;
}
export default class UserSelect extends Component<iProps, iState> {
  private appService: AppService = new AppService();
  state: iState = {
    options: [],
    fetching: false,
  };
  get defaultValue() {
    let { defaultValue = [] } = this.props;
    return defaultValue
  }
  get value() {
    let { value = [] } = this.props;
    return value
  }
  search = async (searchText = "") => {
    let { url = "", userType = "TEACHER,STUDENT", params = {} } = this.props;
    let options = await this.appService.getPersonData({
      url,
      searchText,
      userType,
      params
    });
    this.setState({ options, fetching: false });
  };
  componentDidMount() {
    this.search();
  }
  handleChange = async (selectedItems) => {
    this.props.onChange(selectedItems);
    if (selectedItems.length == 0) {
      this.search();
    }
  };
  handleSearch = async (searchText) => {
    await this.setState({ fetching: true });
    this.search(searchText);
  };
  handleBlur=()=>{
    this.search();
  }
  render() {
    const { placeholder = "请选择", allowClear = true, disabledComp = false } = this.props;
    const { fetching, options } = this.state;
    const filteredOptions = options.filter(
      (o) => !this.props.value.some((selectedItem) => selectedItem == o.userId)
    );
    return (
      <Select
        disabled={disabledComp}
        labelInValue={true}
        defaultValue={this.defaultValue}
        value={this.value}
        allowClear={allowClear}
        onSearch={this.handleSearch}
        onBlur={this.handleBlur}
        mode="multiple"
        dropdownClassName="user-select"
        placeholder={placeholder}
        dropdownMatchSelectWidth={false}
        filterOption={false}
        onChange={this.handleChange}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        style={{ width: "100%" }}
      >
        {filteredOptions.map((item: Person) => (
          <Option  value={item.userId}  key={item.userId}>
            {/* <MyIcon type={`icon${item.userType.toLowerCase()}`} /> */}
            {item.fullname}
          </Option>
        ))}
      </Select>
    );
  }
}
